<div class="material-datatables">
  <table id="selectItems" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
    <thead>
      <tr>
          <th class="disabled-sorting" *ngIf="ticketStatus === 'pending'">
           <b>
            <a class="btn btn-link btn-primary btn-just-icon select-all">
              <i class="material-icons">{{checkAllNew() ? 'check_box' : 'check_box_outline_blank'}}</i>
            </a>
            <!-- ({{bulk.length}}) -->
            </b>
          </th>
          <th class="disabled-sorting" *ngIf="ticketStatus !== 'pending'">
           <b>
            <a class="btn btn-link btn-primary btn-just-icon">
              <i class="material-icons">highlight_off</i>
            </a>
            <!-- ({{bulk.length}}) -->
            </b>
          </th>
          <th > <b> Id </b> </th>
          <th> <b> Container Type </b> </th>
        
         
          <th> <b> Damage </b> </th>
          <th> <b> Date Received </b> </th>
          <th *ngIf="status"> <b> From </b> </th>
          <th> <b> {{status ? 'Destination' : 'Location'}} </b> </th>
          <th *ngIf="status"> <b> Status </b> </th>
          <th *ngIf="!status"> <b> Stage </b> </th>
          <th *ngIf="status" style="text-align: right;"> <b> Comments </b> </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of data">
        <td>
          <a class="btn btn-link btn-info btn-just-icon"  *ngIf='item.internalLocation.id != askedLocation && ticketStatus === "pending"' (click)="selectItem(item.id, item.internalLocation.id)">
            <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
          </a>
           <a class="btn btn-link btn-info btn-just-icon" *ngIf="askedLocation == item.internalLocation.id || ticketStatus !== 'pending'" >
            <i class="material-icons">highlight_off</i>
          </a>

          
        </td>
        <td>{{item.id}}</td>
        <td>{{item.item}}</td>
       
       
        <td>{{item.damages}}</td>
        <td>{{item.createdAt | date : 'MM-dd-yyyy'}}</td>
        <td *ngIf="status">
          {{item.from}}
        </td>
        <td *ngIf="!status"> <span >
          {{item.internalLocation !==  null ? item.internalLocation.locationName + ': ' + item.internalLocation.locationRow + ' - ' +
          item.internalLocation.locationBay + ' - ' + item.internalLocation.locationLevel + ' - ' + item.internalLocation.locationSection : ''}}
        </span></td>
        <td *ngIf="status"><span *ngIf="item.status !== 'pending'">
                    {{item.destination}}
        </span></td>
         <td *ngIf="status">
          <button class="btn btn-sm {{item.status === 'pending' ? 'btn-warning' : 'btn-info'}}">
            {{item.status}}
          </button>
        </td>
        <td *ngIf="!status"><span *ngIf="item.isPi == 1">1</span> <span *ngIf="item.isPi == 0">2</span> <span *ngIf="item.isPi == 3">3</span> <span *ngIf="item.isPi == 4">4</span> </td>
        <td  *ngIf="status" style="text-align: right;">
          <button class="btn btn-warning btn-sm" (click)="openComments(item)">
            Add
          </button>
        </td>
      </tr>
    </tbody>

  </table>
</div>